"use client";

// packages/eden-code-block/src/index.jsx
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Highlight, themes } from "prism-react-renderer";
import { Ghost } from "@churchofjesuschrist/eden-buttons";
import {
  grey10,
  grey60,
  spacing16,
  spacing32,
  borderRadius
} from "@churchofjesuschrist/eden-style-constants";
import { AppearanceSection } from "@churchofjesuschrist/eden-appearance";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var CommentColor = "rgb(162, 191, 252)";
var Pre = styled.pre`
  border-radius: ${borderRadius};
  display: block;
  overflow-x: auto;
  padding: ${spacing32} ${spacing16};
  background: ${grey60};
  color: ${grey10};
  margin: 0;
  white-space: pre;
  position: relative;
`;
var CopyButton = styled(Ghost)`
  position: absolute;
  top: 0;
  right: 0;
`;
var LineNumber = styled.span`
  &::before {
    content: attr(data-line-number);
  }
`;
var CodeBlock = ({
  children,
  language = "jsx",
  lineNumbers = false,
  copyButton = false
}) => {
  const [copied, setCopied] = useState("Copy");
  const handleCopyClick = () => {
    window.navigator.clipboard?.writeText(children).then(() => {
      setCopied("Copied");
    }).catch(() => {
      setCopied("Error");
    });
  };
  useEffect(() => {
    const timeOut = setTimeout(() => {
      setCopied("Copy");
    }, 2e3);
    return () => clearTimeout(timeOut);
  }, [copied]);
  if (typeof children !== "string") {
    return null;
  }
  return /* @__PURE__ */ jsx(Highlight, { theme: PrismTheme, code: children, language, children: ({ className, style, tokens, getLineProps, getTokenProps }) => /* @__PURE__ */ jsxs(Pre, { className, style, children: [
    copyButton ? /* @__PURE__ */ jsx(AppearanceSection, { mode: "dark", style: { background: "none" }, children: /* @__PURE__ */ jsx(CopyButton, { onClick: handleCopyClick, children: copied }) }) : null,
    tokens.map((line, i) => /* @__PURE__ */ createElement("div", { ...getLineProps({ line }), key: i }, lineNumbers ? /* @__PURE__ */ jsx(
      LineNumber,
      {
        className: "token comment",
        "data-line-number": (i + 1 + "|").padStart(3),
        style: {
          userSelect: "none",
          color: CommentColor
        }
      },
      i
    ) : null, line.map((token, key) => /* @__PURE__ */ createElement("span", { ...getTokenProps({ token }), key }))))
  ] }) });
};
var PrismTheme = {
  ...themes.nightOwl,
  styles: [
    ...themes.nightOwl.styles,
    {
      types: ["attr-value", "hexcode"],
      style: {
        color: "rgb(255, 203, 139)"
      }
    },
    {
      types: ["comment"],
      style: {
        color: CommentColor,
        fontStyle: "normal"
      }
    }
  ]
};
CodeBlock.displayName = "CodeBlock";
export {
  CodeBlock
};
